import React from "react";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-content">
        <div className="footer-main">
          <p>Celebrate Recovery • Thursdays at 7:00 PM</p>
          <p>Led by John and Terri Daugherty</p>
          <p>A safe place for healing from hurts, habits, and hang-ups.</p>
        </div>

        <div className="footer-credit">
          <a
            href="https://www.needhamtechstudio.com"
            target="_blank"
            rel="noopener noreferrer"
            className="designer-link"
          >
            <img
              src="/NeedhamTechLogo.webp"
              alt="Needham Tech Studio"
              className="designer-logo"
            />
            <span>Designed by Needham Tech Studio</span>
          </a>

          <a href="/admin" className="footer-admin-link">Admin</a>
        </div>
      </div>
    </footer>
  );
}